import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { AddMember } from '../../Redux/action/memberAction';
import { dataUser, logoutHandler, dataLocation } from '../Helpers/util';

import SwPhoneInput from '../Common/SwPhoneInput/SwPhoneInput';
import { toast } from 'react-toastify';
import dayjs from "dayjs";

import { allMember } from '../../Redux/action/memberAction';
import { onCityLocation } from '../../Redux/action/memberAction';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  onBuildingLocation,
  onBuildingLocation1,
  onSPOCLocation,
} from '../../Redux/action/memberAction';
import axios from 'axios';

import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';

import { restrictEqualSign } from '../../Component/Helpers/util';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwButton from '../Common/SwButtons/SwButtons';
import Accordion from 'react-bootstrap/Accordion';
import SwFileUploader from '../Common/SwFileUploader/SwFileUploader';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

var FormData = require('form-data');
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class AddnewMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      fileName1: '',
      fileName3: '',
      fileName: '',
      userid: UserObj ? UserObj.rec_id : null,
      added_by: UserObj ? UserObj.rec_id : null,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      typefile: '',
      classDefalt: false,
      dataAdd: false,
      nfile: null,
      errorLogin: false,
      account_id: UserObj ? UserObj.account_id : null,
      company_id: UserObj ? UserObj.company_id : null,
      business_id: '',
      city_id: null,
      profile:
        'https://d2jovvsod2x1gg.cloudfront.net/new_app/profile_icons/defaultProfile.png',
      certificate: {},
      fname: '',
      lname: '',
      email_id: '',
      phone_no: '',
      location_id: 0,
      status: '1',
      dob: '',
      address: '',
      bgp: '',
      specially_abled: null,
      econtact: '',
      payroll: '',
      date_of_joining: '',
      project: '',
      kyc_type: null,
      gender: null,
      kyc: '',
      emp_code: '',
      designation: '',
      role: '',
      vaccinated: false,
      refreshCity: '',
      refreshBuilding: '',
      refreshFloor: null,
      isSpocDrpdownShow: false,
      globalCheckin: 1,
      globalcheckin1: true,
      orgRole: [],
      role_id: '',
      roleValue: null,
      roleError: '',
      deptValue: null,
      locationSpoc: [],
      Dept_id: '',
      orgDept: [],
      selected: [],
      location: [],
      is_active: null,
      spoc_location: [],
      spoc_location_temp: [],
      spoc_location_erroeMsg: '',
      required: {
        cityName: true,
        buildingName: false,
      },
    };
  }

  componentDidMount = async () => {
    const c_id = JSON.parse(localStorage.getItem('headData'));

    // if (!UserObj?.company_id) {
    //   logoutHandler();
    //   return; // Ensure you stop further execution if the condition is met
    // }

    try {
      const parm2 = {
        user_id: c_id.company_id,
      };

      // Fetch user roles
      let authToken = JSON.parse(localStorage.getItem('headData'));
      const roleResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}userRoles/getRoleList/${this.state.company_id
        }`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );
      if (roleResponse.data && roleResponse.data.status === 'success') {
        this.setState({
          orgRole: roleResponse.data.data.result,
        });
      }

      // Fetch SPOC location data

      const locationParams = {
        params: { spoc: UserObj.rec_id, client: UserObj.company_id },
        headers: {
          Authorization: authToken?.spintlyToken,
        },
      };
      const locationResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        locationParams,
      );

      if (locationResponse.data.status === 'success') {
        this.setState({
          locationSpoc: locationResponse.data.data,
        });
      }
    } catch (error) {
      console.error(error);
      // Handle errors here
    }
  };

  removeClass = () => {
    this.setState({
      classDefalt: true,
    });
  };
  bloodGroupOptions = [
    { value: 'A_NEGATIVE', label: 'A-' },
    { value: 'A_POSITIVE', label: 'A+' },
    { value: 'B_NEGATIVE', label: 'B-' },
    { value: 'B_POSITIVE', label: 'B+' },
    { value: 'AB_NEGATIVE', label: 'AB-' },
    { value: 'AB_POSITIVE', label: 'AB+' },
    { value: 'O_POSITIVE', label: 'O+' },
    { value: 'O_NEGATIVE', label: 'O-' },
  ];

  handlePhoneNumberChange = value => {
    this.setState({ phoneNumber: value });

    if (value !== '') {
      this.setState({ phone_noerrorMsg: '' });
    }
  };

  handleChange4 = city => {
    var required = this.state.required;
    required.buildingName = true;
    this.setState({
      city: city?.value,
      refreshCity: city,
      required: required,
      cityerrorMsg: '',
    });
    let parm = {
      spoc: this.state.userid,
      client: this.state.company_id,
      city: city?.value,
    };

    // this.setState({ city: city.value, refreshCity: city });
    // this.props.onCityLocation1(parm);
    this.props.onBuildingLocation1(parm);
    this.state.refreshBuilding = null;
  };

  handleChange5 = buildingid => {
    let parm = {
      buildingid: buildingid.value,
    };
    this.setState({ refreshFloor: { value: '', label: 'Please select' } });
    this.setState({
      location_id: buildingid.value,
      refreshBuilding: buildingid,
      buildingerrorMsg: null,
    });
    this.props.onBuildingLocation(parm);
    this.getDepDataByLocation(buildingid.value);
  };

  getDepDataByLocation = loc_id => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    // if (!UserObj?.company_id) {
    //   logoutHandler();
    // }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}department/getActiveDepartment/${this.state.company_id
        }/${loc_id}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status == 'success') {
          this.setState({
            orgDept: response.data.data.activeDepartment,
          });
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
  };

  handleChange = (val, name) => {
    this.setState({
      business_id: val.value,
      refreshFloor: val,
      buildingerrorMsg1: '',
    });
  };

  addMemeberHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    if (event.target.value != '') {
      this.setState({
        [event.target.name + 'errorMsg']: '',
      });
    }
  };

  addMemeberHandlerEmpCode = event => {
    this.setState({
      [event.target.name]: event.target.value.replace(/[^\w\s]/gi, ''),
    });
    if (event.target.value != '') {
      this.setState({
        [event.target.name + 'errorMsg']: '',
      });
    }
  };

  uploadImg = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        profile: convertBase64,
        nfile: URL.createObjectURL(event.target.files[0]),
        typefile: event.target.files[0].name.split('.')[1],
        nfileerrorMsg: null,
      });
    };
    let formData = new FormData();
    formData.append('single_file', event.target.files[0]);
    axios
      .post(
        `${process.env.REACT_APP_API_URL
        }basic-data/single-img-upload?folder=app_profile`,
        formData,
      )
      .then(response => {
        if (response.data.statusValue == 200) {
          this.setState({ profile: response.data.payload.fileData.filePath });
          toast.success(response.data.message);
        }
      });
  };

  uploadImgfile = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        kyc: convertBase64,
        fileName1: event.target.files[0].name,
      });
    };
    let formData = new FormData();
    formData.append('single_file', event.target.files[0]);
    axios
      .post(
        `${process.env.REACT_APP_API_URL
        }basic-data/single-img-upload?folder=kyc_proof`,
        formData,
      )
      .then(response => {
        if (response.data.statusValue == 200) {
          this.setState({ kyc: response.data.payload.fileData.filePath });
          toast.success(response.data.message);
        }
      });
  };

  uploadImgfile2 = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        certificate: convertBase64,
        fileName: event.target.files[0].name,
      });
    };
  };



handleCertificateChange = (files) => {
  if (!files.length) {
    this.setState({ fileList: [] });
    return;
  }

  const file = files[0];

  this.setState({ fileList: files });

  // 🔹 Case 1: Base64
  if (this.state.vaccinated == 1) {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      this.setState({
        certificate: fileReader.result,
        fileName: file.name,
        fileerrorMsg: "",
      });
    };
  }

  // 🔹 Case 2: Upload to API
  if (this.state.vaccinated == 2) {
    const formData = new FormData();
    formData.append(
      "single_file",
      file
    );

    axios
      .post(
        `${process.env.REACT_APP_API_URL}basic-data/single-img-upload?folder=vaccination_certificate`,
        formData
      )
      .then((response) => {
        if (response.data.statusValue == 200) {
          this.setState({
            certificate: response.data.payload.fileData.filePath,
            fileName: file.name,
            fileerrorMsg: "",
          });
          toast.success(response.data.message);
        }
      })
      .catch(() => {
        this.setState({ fileerrorMsg: "Upload failed" });
        toast.error("File upload failed");
      });
  }
};




  

  onChangeValue = event => {
    this.setState({
      fileName3: '',
    });
    this.setState({
      fileName: '',
    });
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  changeBldGroup = value => {
    this.setState({ bgp: value });
  };

  changespecAbled = value => {
    this.setState({ specially_abled: value });
  };
  speciallyAbledOptions = [
    { value: 'YES', label: 'Yes' },
    { value: 'NO', label: 'No' },
  ];

  changeKycType = value => {
    this.setState(prevState => ({
      kyc_type: value,
      dis: !prevState.dis,
    }));
  };

  changeGender = value => {
    this.setState({ gender: value });
  };

  changeSelect = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  changeRole = role => {
    this.setState({
      roleValue: role,
      roleError: '',
    });
  };

  list = new Set();

  handelMultySelect = e => {
    e.map(items => {
      this.list.add(parseInt(items.value));
    });
    this.setState({
      selected: e,
      location: Array.from(this.list),
    });
  };

  changeDept = department => {
    this.setState({
      deptValue: department,
    });
  };

  handleSpocRadio = () => {
    this.setState({
      isSpocDrpdownShow: true, // Set to true when "Yes" is selected
      roleError: '',
    });
  };

  handleSpocRadio1 = () => {
    this.setState({
      isSpocDrpdownShow: false, // Set to false when "No" is selected
      roleError: '',
      roleValue: null,
      spoc_location_temp: [],
      selected: [],
    });
  };
  kycTypeOptions = [
    { value: 'AADHAR', label: 'Aadhar' },
    { value: 'PAN', label: 'PAN' },
    { value: 'PASSPORT', label: 'Passport' },
    { value: 'VOTERID', label: 'Voter Identity Card' },
    { value: 'NREGA', label: 'NREGA Card' },
    { value: 'DL', label: 'Driving License' },
  ];

  genderOptions = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
    { value: 'OTHERS', label: 'Others' },
  ];

  handelMultyBuildingSelect = e => {
    var list = [];
    e.map(items => {
      list.push(parseInt(items.value));
      // list.add({ dept_id: items.value, dept_name: items.label });
    });
    this.setState({
      spoc_location_temp: e,
      spoc_location: list,
      spoc_location_erroeMsg: '',
      selected: [],
    });
    this.getDepDataByLocation(list);
  };



  handleKycUpload = async (files) => {
    const file = Array.isArray(files) ? files[0] : files;
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      this.setState({ fileerrorMsg: "Only PDF, JPG, PNG allowed" });
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      this.setState({ fileerrorMsg: "File must be under 5MB" });
      return;
    }

    this.setState({
      fileerrorMsg: "",
      fileName1: file.name,
    });

    let formData = new FormData();
    formData.append("single_file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}basic-data/single-img-upload?folder=kyc_proof`,
        formData
      );

      if (response.data.statusValue === 200) {
        this.setState({
          kyc: response.data.payload.fileData.filePath,
        });

        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error("File upload failed");
    }
  };

  addmemberSubmitHandler = async e => {
    e.preventDefault();

    // 🔹 Reset previous errors
    this.setState({
      fnameerrorMsg: '',
      email_iderrorMsg: '',
      phone_noerrorMsg: '',
      cityerrorMsg: '',
      buildingerrorMsg: '',
      buildingerrorMsg1: '',
      roleError: '',
      spoc_location_erroeMsg: '',
    });

    // 🔹 Step 1: Validate First Name
    if (this.state.fname.trim() === '') {
      this.setState({ fnameerrorMsg: 'Please Enter First Name' });
      return;
    }

    // 🔹 Step 2: Validate Email
    if (
      this.state.email_id.trim() === '' ||
      !/[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z]{2,8})?/g.test(
        this.state.email_id
      )
    ) {
      this.setState({ email_iderrorMsg: 'Please Enter a valid Email Id' });
      return;
    }

    // 🔹 Step 3: Validate Phone Number
    if (
      this.state.phoneNumber.trim() === '' ||
      this.state.phoneNumber.length < 10 ||
      this.state.phoneNumber.length > 16
    ) {
      this.setState({
        phone_noerrorMsg: 'Please Enter a valid Mobile Number',
      });
      return;
    }

    // 🔹 Step 4: Validate City
    if (this.state.refreshCity === '') {
      this.setState({ cityerrorMsg: 'Please select a City' });
      return;
    }

    // 🔹 Step 5: Validate Building
    if (this.state.refreshBuilding === null) {
      this.setState({ buildingerrorMsg: 'Please Select a Building' });
      return;
    }

    // 🔹 Step 6: Validate Floor
    if (this.state.business_id === '') {
      this.setState({ buildingerrorMsg1: 'Please Select a Floor' });
      return;
    }

    // 🔹 Step 7: SPOC Validations
    if (this.state.isSpocDrpdownShow) {
      if (!this.state.roleValue) {
        this.setState({ roleError: 'Please select a Role' });
        return;
      }

      if (this.state.spoc_location.length === 0) {
        this.setState({
          spoc_location_erroeMsg: 'Please select at least one Location Name',
        });
        return;
      }
    }

    // 🔹 Build API payload
    const param = {
      profile_img_url: this.state.profile,
      fname: this.state.fname,
      lname: this.state.lname,
      emp_code: this.state.emp_code,
      email: this.state.email_id,
      phone: this.state.phoneNumber?.replace(/^\+/, ''),
      property_id: this.state.refreshBuilding.value,
      organization_id: this.state.company_id,
      user_dept_id: this.state.deptValue?.value,
      isSpoc: this.state.isSpocDrpdownShow,
      user_role_id: this.state.roleValue?.value || null,
      spoc_location: this.state.spoc_location,
      deptSpoc: this.state.selected?.map(item => item.value),
      isGlobalCheckInOut: Number(this.state.globalCheckin),
      dob: this.state.dob,
      address: this.state.address,
      vaccinated: this.state.vaccinated,
      blood_group: this.state.bgp,
      emergency_contact: this.state.econtact,
      kyc_type: this.state.kyc_type,
      kyc_file: this.state.kyc,
      gender: this.state.gender,
      specially_abled: this.state.specially_abled,
      date_of_joining: this.state.date_of_joining,
      designation: this.state.designation,
      payroll: this.state.payroll,
      project: this.state.project,
    };

    try {
      // 🔥 WAIT for API response
      const result = await this.props.AddMember(param);

      if (result?.success) {
        // ✅ Close modal + success toast handled by parent
        this.props.onClose(true, result.message);

        // ✅ Reset form AFTER success
        this.setState({
          fname: '',
          lname: '',
          email_id: '',
          phoneNumber: '',
          location_id: 0,
          status: 1,
          dob: '',
          address: '',
          bgp: '',
          econtact: '',
          kyc_type: '',
          nfile: null,
          dataAdd: true,
          designation: '',
          role: '',
          roleValue: null,
          emp_code: '',
          spoc_location: [],
          spoc_location_temp: [],
        });
      } else {
        // ❌ API failed → modal stays open
        toast.error(result?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error('Unexpected error occurred');
    }
  };


  componentWillReceiveProps(props) {
    if (props.CityNameReducer && props.CityNameReducer.length != 0) {
      this.setState({
        cityApiData: props.CityNameReducer,
      });
    }
    if (
      this.state.dataAdd == true &&
      props.ActiveDataUPload &&
      props.ActiveDataUPload.data &&
      props.ActiveDataUPload.data.status == 200
    ) {
      this.setState({
        dataAdd: false,
      });
      let param = {
        pgno: 1,
        row: 10,
        company_id: this.state.company_id,
      };
      this.props.allMember(param);
    }

    if (
      this.state.dataAdd == true &&
      props.ActiveDataUPload &&
      props.ActiveDataUPload.data &&
      props.ActiveDataUPload.data.status_message ==
      'Member registered Successfully'
    ) {
      this.setState({
        dataAdd: false,
        refreshCity: null,
        refreshBuilding: null,
        refreshFloor: null,
        fname: '',
        lname: '',
        email_id: '',
        phone_no: '',
        cityid: '',
        address: '',
        blood_group: '',
        emergency_contact: '',
        kyc_type: '',
        rec_id: '',
      });
    }
  }

  reload = e => {
    this.setState({
      fname: '',
      lname: '',
      email_id: '',
      status: 1,
      phone_no: '',
      address: '',
      blood_group: '',
      emergency_contact: '',
      kyc_type: '',
      rec_id: '',
      roleValue: '',
      designation: '',
      refreshCity: '',
      refreshBuilding: '',
      refreshFloor: '',
      selected: [],
      deptValue: '',
      nfile: null,
      fileName: '',
      fileName1: '',
      kyc_type: '',
      bgp: '',
      dob: '',
      econtact: '',
      vaccinated: 0,
      isSpocDrpdownShow: false,
      emp_code: '',
      spoc_location_temp: [],
    });
  };

  render() {
    const attendenceSiftAssign = this.state.userRole.find(
      element => element.service_id == '25',
    );
    var stateall = this.state;
    const { popUp } = this.props;
    const NewCity = this.props.CityData1.CityData1;

    const BuildingData1 = this.props.CityData1.BuildingData1;
    const Floordata = this.props.BuildingData?.BuildingData;
    const newMember = this.props.newMemberData.NewMemberData;
    const BuildingSPOCNames = this.props.BuildingSPOCData;
    //--City--///
    const options4 = [];

    if (NewCity !== 0) {
      NewCity &&
        NewCity.map((items, i) => {
          options4.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--building--///
    const Bhuildig1 = [];
    if (BuildingData1 !== 0) {
      BuildingData1 &&
        BuildingData1.map((items, i) => {
          Bhuildig1.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }

    const buildingNamesSPOC = [];
    if (this.state.locationSpoc !== 0) {
      this.state.locationSpoc &&
        this.state.locationSpoc.map((items, i) => {
          buildingNamesSPOC.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }

    //--building---///
    //--floor--///
    const options6 = [];
    if (Floordata !== 0) {
      Floordata &&
        Floordata?.map((items, i) => {
          options6.push({
            value: items.rec_id,
            label: items.business_name,
          });
        });
    }

    const options7 = [];
    this.state.orgDept.map(dept =>
      options7.push({ value: dept.id, label: dept.dept_name }),
    );

    const options8 = [];
    this.state.orgRole.map(role =>
      options8.push({ value: role.id, label: role.role_name }),
    );

    return (
      <>
        <div className="row">
          <div className="col-12 mb-3">
            <label className="setimgArea">
              <input
                type="file"
                className="Uploadfilebtn parset"
                onChange={e => {
                  this.uploadImg(e);
                }}
              />
              <span>+</span>
              Add Image
              <div className="imgSFigure">
                <img src={this.state.nfile} />
              </div>
            </label>
            {/* <span className="SwTextDanger SwTextSmall">{this.state.nfileerrorMsg}</span> */}
          </div>
        </div>


        {/* SW-UI Accordion V2 */}
        <Accordion
          defaultActiveKey={['0']}
          className="SwAccordionV2 NoBorder SwAccordionV2-sm"
          alwaysOpen
        >

          {/* ================= BASIC DETAILS ================= */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Basic Details
            </Accordion.Header>

            <Accordion.Body>

              {/* 👇 PASTE YOUR EXISTING BASIC DETAILS FORM HERE */}

              <div className="row">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      First Name <span className="Required">*</span>
                    </label>

                    <SwInput
                      type="text"
                      name="fname"
                      maxLength={20}
                      value={this.state.fname}
                      onChange={this.addMemeberHandler}
                      onKeyPress={restrictEqualSign}
                      placeholder="Enter First Name"
                    />

                    {this.state.fnameerrorMsg && (
                      <span className="SwTextDanger SwTextSmall">
                        {this.state.fnameerrorMsg}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Last Name</label>

                    <SwInput
                      type="text"
                      name="lname"
                      value={this.state.lname}
                      onChange={this.addMemeberHandler}
                      onKeyPress={restrictEqualSign}
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Employee Code</label>

                    <SwInput
                      type="text"
                      name="emp_code"
                      value={this.state.emp_code}
                      onChange={this.addMemeberHandlerEmpCode}
                      placeholder="Enter Employee Code"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Corporate Email <span className="Required">*</span>
                    </label>

                    <SwInput
                      type="text"
                      name="email_id"
                      value={this.state.email_id}
                      onChange={this.addMemeberHandler}
                      onKeyPress={restrictEqualSign}
                      placeholder="Enter Corporate Email"
                    />

                    <span className="SwTextDanger SwTextSmall">
                      {this.state.email_iderrorMsg}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">

                  <div className='SwFormGroup'>
                    <label className="SwFormLabel">
                      Mobile Number<span className="Required">*</span>
                    </label>

                    <SwPhoneInput
                      value={this.state.phoneNumber}
                      onChange={this.handlePhoneNumberChange}
                      placeholder="Enter mobile number"
                      defaultCountry="in"
                      error={!!this.state.phone_noerrorMsg}
                      errorMsg={this.state.phone_noerrorMsg}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div class="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      City <span className="Required">*</span>
                    </label>
                    <SwSelect
                      value={this.state.refreshCity}
                      onChange={this.handleChange4}
                      options={options4}
                      isClearable={false}
                    />
                  </div>
                  <span className="SwTextDanger SwTextSmall">
                    {this.state.cityerrorMsg}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Building <span className="Required">*</span>
                    </label>
                    <SwSelect
                      value={this.state.refreshBuilding}
                      onChange={this.handleChange5}
                      options={Bhuildig1}
                      isClearable={false}
                    />
                  </div>
                  <span className="SwTextDanger SwTextSmall">
                    {this.state.buildingerrorMsg}
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Floor <span className="Required">*</span>
                    </label>
                    <SwSelect
                      value={this.state.refreshFloor}
                      onChange={e => this.handleChange(e, 'building')}
                      options={options6}
                      isClearable={false}
                    />
                  </div>
                  <span className="SwTextDanger SwTextSmall">
                    {this.state.buildingerrorMsg1}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-md-6">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Employee Department
                    </label>
                    <SwSelect
                      value={this.state.deptValue}
                      options={options7}
                      onChange={this.changeDept}
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12" />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Spoc <span className="Required">*</span>
                    </label>

                    <div>
                      <SwRadio
                        id="spocYes"
                        name="spoc"
                        label="Yes"
                        checked={this.state.isSpocDrpdownShow}
                        onChange={this.handleSpocRadio}
                        inline
                      />

                      <SwRadio
                        id="spocNo"
                        name="spoc"
                        label="No"
                        checked={!this.state.isSpocDrpdownShow}
                        onChange={this.handleSpocRadio1}
                        inline
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {this.state.isSpocDrpdownShow && (
                  <div className="col-lg-12 col-md-6">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">
                        Role
                        <span className="Required">*</span>
                      </label>
                      <SwSelect
                        value={this.state.roleValue}
                        options={options8}
                        onChange={this.changeRole}
                        isClearable={false}
                      />
                      <span className="SwTextDanger SwTextSmall">
                        {this.state.roleError}
                      </span>
                    </div>
                  </div>
                )}
                {/* <br /> */}
              </div>

              <div className="row">
                {this.state.isSpocDrpdownShow && (
                  <div className="col-lg-12 col-md-6">
                    <div className="formAddmemGrid">
                      <label>
                        Location Name
                        <span className="ixon">*</span>
                      </label>

                      <SwMultiSelect
                        options={buildingNamesSPOC}
                        value={this.state.spoc_location_temp}
                        onChange={this.handelMultyBuildingSelect}
                        labelledBy="Select"
                      />

                      <span className="SwTextDanger SwTextSmall">
                        {this.state.spoc_location_erroeMsg}
                      </span>
                    </div>
                  </div>
                )}
              </div>


              <div className="row">
                {this.state.isSpocDrpdownShow && (
                  <div className="col-lg-12 col-md-6">
                    <div className="formAddmemGrid">
                      <label>SPOC Department</label>

                      <SwMultiSelect
                        options={options7}
                        value={this.state.selected}
                        onChange={this.handelMultySelect}
                        labelledBy="Select"
                      />
                    </div>
                  </div>
                )}
              </div>

              {attendenceSiftAssign &&
                attendenceSiftAssign.role_for_write == '1' ? (
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">
                        Global Checkin <span className="Required">*</span>
                      </label>

                      <div>
                        <SwRadio
                          id="globalCheckinYes"
                          name="globalCheckin"
                          label="Yes"
                          checked={this.state.globalcheckin1}
                          onChange={e =>
                            this.setState({
                              [e.target.name]: e.target.value,
                              globalcheckin1: true,
                            })
                          }
                          value={1}
                          inline
                        />

                        <SwRadio
                          id="globalCheckinNo"
                          name="globalCheckin"
                          label="No"
                          checked={!this.state.globalcheckin1}
                          onChange={e =>
                            this.setState({
                              [e.target.name]: e.target.value,
                              globalcheckin1: false,
                            })
                          }
                          value={0}
                          inline
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}

            </Accordion.Body>
          </Accordion.Item>

          {/* ================= ADDITIONAL DETAILS ================= */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Additional Details (Optional)
            </Accordion.Header>

            <Accordion.Body>

              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Date of Birth</label>

                    <AntDDatePicker
                      name="dob"
                      value={this.state.dob ? dayjs(this.state.dob) : null}
                      onChange={(date) =>
                        this.setState({
                          dob: date ? date.format("YYYY-MM-DD") : "",
                        })
                      }
                      format="DD/MM/YYYY"
                      placeholder="Select Date of Birth"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Address</label>

                    <SwTextArea
                      name="address"
                      value={this.state.address}
                      onChange={this.addMemeberHandler}
                      placeholder="Enter address"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Vaccinated</label>

                    <div onChange={this.onChangeValue}>
                      <SwRadio
                        id="vaccinated_yes"
                        name="vaccinated"
                        label="Yes"
                        value="1"
                        checked={this.state.vaccinated == 1}
                        inline
                      />

                      <SwRadio
                        id="vaccinated_no"
                        name="vaccinated"
                        label="No"
                        value="0"
                        checked={this.state.vaccinated == 0}
                        inline
                      />
                    </div>
                  </div>
                </div>
              </div>
          {(this.state.vaccinated == 1 || this.state.vaccinated == 2) && (
  <div className="row">
    <div className="col-md-12 col-lg-12">
      <div className="formAddmemGrid">
        <label>Upload Certificate*</label>

        <SwFileUploader
          multiple={false}
          maxSizeMB={5}
          accept=".pdf,.jpg,.jpeg,.png"
          showUploadButton={true}
          helperText="Upload vaccination certificate (PDF/Image, Max 5MB)"
          fileList={this.state.fileList || []}
          onChange={this.handleCertificateChange}
        />

        {this.state.fileerrorMsg && (
          <span className="SwTextDanger SwTextSmall">
            {this.state.fileerrorMsg}
          </span>
        )}
      </div>
    </div>
  </div>
)}
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Blood Group</label>

                    <SwSelect
                      options={this.bloodGroupOptions}
                      value={
                        this.bloodGroupOptions.find(
                          option => option.value === this.state.bgp,
                        ) || null
                      }
                      onChange={selectedOption =>
                        this.changeBldGroup(selectedOption?.value)
                      }
                      placeholder="Select your Blood Group"
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Emergency Contact Number
                    </label>

                    <SwInput
                      type="number"
                      name="econtact"
                      value={this.state.econtact}
                      onChange={this.addMemeberHandler}
                      placeholder="Emergency Contact Number"
                      maxLength={12}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-8">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">KYC Proof</label>

                    <SwSelect
                      options={this.kycTypeOptions}
                      value={
                        this.kycTypeOptions.find(
                          option => option.value === this.state.kyc_type
                        ) || null
                      }
                      onChange={selectedOption =>
                        this.changeKycType(selectedOption?.value)
                      }
                      placeholder="Select KYC Proof"
                      isClearable={false}
                    />
                  </div>
                </div>

                {/* Show uploader only when KYC type selected */}
                {this.state.kyc_type && (
                  <div className="col-md-12 col-lg-4">
                    <div className="formAddmemGrid">
                      <label>Upload KYC*</label>

                      <SwFileUploader
                        multiple={false}
                        maxFiles={1}
                        maxSizeMB={5}
                        accept=".pdf,.jpg,.jpeg,.png"
                        showUploadButton={true}
                        helperText="Upload KYC (PDF/Image, Max 5MB)"
                        onChange={this.handleKycUpload}
                      />

                      {this.state.fileName1 && (
                        <p style={{ fontSize: "12px", marginTop: "5px" }}>
                          {this.state.fileName1}
                        </p>
                      )}

                      {this.state.fileerrorMsg && (
                        <span className="SwTextDanger SwTextSmall">
                          {this.state.fileerrorMsg}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Gender</label>

                    <SwSelect
                      options={this.genderOptions}
                      value={
                        this.genderOptions.find(
                          option => option.value === this.state.gender,
                        ) || null
                      }
                      onChange={selectedOption =>
                        this.changeGender(selectedOption?.value)
                      }
                      placeholder="Select Gender"
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Specially abled</label>

                    <SwSelect
                      options={this.speciallyAbledOptions}
                      value={
                        this.speciallyAbledOptions.find(
                          option =>
                            option.value === this.state.specially_abled,
                        ) || null
                      }
                      onChange={selectedOption =>
                        this.changespecAbled(selectedOption?.value)
                      }
                      placeholder="Select"
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="formAddmemGrid">
                    <label>Date of Joining</label>

                    <AntDDatePicker
                      name="date_of_joining"
                      value={
                        this.state.date_of_joining
                          ? dayjs(this.state.date_of_joining)
                          : null
                      }
                      onChange={(date) =>
                        this.setState({
                          date_of_joining: date
                            ? date.format("YYYY-MM-DD")
                            : "",
                        })
                      }
                      format="DD/MM/YYYY"
                      placeholder="Select Date of Joining"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Designation</label>

                    <SwInput
                      type="text"
                      name="designation"
                      value={this.state.designation}
                      onChange={this.addMemeberHandler}
                      placeholder="Designation"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Payroll Vendor</label>

                    <SwInput
                      type="text"
                      name="payroll"
                      value={this.state.payroll}
                      onChange={this.addMemeberHandler}
                      placeholder="Payroll Vendor"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Project</label>

                    <SwInput
                      type="text"
                      name="project"
                      value={this.state.project}
                      onChange={this.addMemeberHandler}
                      placeholder="Project"
                    />
                  </div>
                </div>
              </div>

            </Accordion.Body>
          </Accordion.Item>

        </Accordion>

      </>
    );
  }
}

const mapStateToProps = state => ({
  UI: state.UI,
  newMemberData: state.activeUserList,
  CityData: state.activeUserList,
  ActiveDataUPload: state.activeUserList.AcitvmemberListAdd,
  CityNameReducer: state.roomTraingReducer.TrainingRoomCityData,
  BuildingSPOCData: state.activeUserList.BuildingSPOCData,
  CityData1: state.activeUserList,
  BuildingData: state.activeUserList,
});

const mapActionsToProps = {
  AddMember,
  allMember,
  onCityLocation,
  onBuildingLocation,
  onBuildingLocation1,
  onSPOCLocation,
};
const AddnewMemberWithRef = React.forwardRef((props, ref) => (
  <AddnewMember {...props} ref={ref} />
));

export default connect(
  mapStateToProps,
  mapActionsToProps,
  null,
  { forwardRef: true }, // 🔥 THIS IS REQUIRED
)(AddnewMemberWithRef);
